'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _sharedStyles = require('./shared-styles');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var readOnlyStyles = function readOnlyStyles(_ref) {
  var theme = _ref.theme;
  return Object.assign({}, (0, _sharedStyles.formControl)(theme), {
    padding: theme.space_sm
  });
};
var ReadOnly = (0, _glamorous2.default)('div')(readOnlyStyles);
exports.default = ReadOnly;